import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';
import { Button } from '@mui';
import { errorDataField, updateDataField } from '@actions/data-detail-actions';
import { colors } from '@constants/colors';
import { getEntityTypeLabel } from '@constants/config';
import './error-id-exists.scss';

const ErrorIdExists = ({ dataType }) => {
  const dispatch = useDispatch();
  const { error } = useSelector(state => state.dataDetail);

  const entityTypeLabel = getEntityTypeLabel(dataType);
  const expectedError = `Provided ${entityTypeLabel} id does not exist`;

  const onCreateNew = useCallback(() => {
    dispatch(errorDataField('id', null, true));
    dispatch(updateDataField('id', null));
  }, [dispatch]);

  if (error?.id?.includes(expectedError)) {
    return (
      <div role="alert" styleName="error-id-exists-container">
        <div styleName="error-icon">
          <ErrorOutlineIcon htmlColor={colors.brand.red} style={{ fontSize: '1.5rem' }} />
        </div>
        <div styleName="error-message">
          We couldn't find an existing entity with the
          <span styleName="error-bold">
            &nbsp;Entity ID.
          </span>
          You might skip this entity or create a new entity.
        </div>
        <div styleName="error-action">
          <Button
            onClick={onCreateNew}
            style={{ color: '#541313' }}
          >
            CREATE NEW
          </Button>
        </div>
      </div>
    );
  }

  return null;
};

ErrorIdExists.propTypes = {
  dataType: PropTypes.string.isRequired
};

export default memo(ErrorIdExists);
